<!-- use tags -->

import Layout1 from "../../src/routes/+layout.marko";
import Layout2 from "../../src/routes/docs/+layout.marko";
import Page from "../../src/routes/docs/_compiled-docs/explanation/serializable-state+page.marko";

<Layout1>
	<Layout2>
		<Page/>
	</>
</>
